import React from "react";
import "./Loading2.css";


function LoadingScreen({ text= "Loading dashboard" }) {
  return (
    <div className="loading-screen2">
      <div className="loader-container2">
        <div className="loader-wrapper">
          <div className="loader2" />
        </div>
        
        <div className="text-container">
          {text}
        </div>
      </div>
    </div>
  );
}

export default LoadingScreen;
